import React, { CSSProperties, FC, memo, ReactNode, useCallback, useState } from 'react';
import { InputBase, InputAdornment, IconButton } from '@material-ui/core';
import { Clear, Search } from '@material-ui/icons';
import { useStyles } from './styles';
import { SearchIcon } from '../../CustomIcons';

const searchDelay = 500; // ms, reduce unnecessary updates while typing

interface SearchFieldProps {
  placeholder?: string;
  type?: string;
  showReset?: boolean;
  onSearch: (value: string) => void;
  startComponent?: ReactNode;
  style?: CSSProperties;
}

export const SearchField: FC<SearchFieldProps> = memo(({ placeholder, type, showReset, onSearch, startComponent, style }) => {
  const classes = useStyles();
  const [timeoutId, setTimeoutId] = useState<number>();
  const [searchValue, setSearchValue] = useState('');
  const [showSearch, setShowSearch] = useState<boolean>(false);

  const handleChange = useCallback(
    (event) => {
      // delay search
      if (timeoutId) clearTimeout(timeoutId);
      const timeout: number = setTimeout(() => {
        onSearch(event.target.value);
      }, searchDelay) as unknown as number;

      setTimeoutId(timeout);
      setSearchValue(event.target.value);
    },
    [onSearch, timeoutId],
  );

  const handleReset = () => {
    setSearchValue('');
    onSearch('');
    setShowSearch(false);
  };

  return (
    <>
      <IconButton
        className={showSearch ? classes.hideSearch : ''}
        onClick={() => {
          setShowSearch(true);
        }}
      >
        <SearchIcon />
      </IconButton>
      <InputBase
        autoFocus
        placeholder={placeholder || 'Search'}
        value={searchValue}
        onChange={handleChange}
        className={`${classes.root} ${!showSearch ? classes.hideSearch : ''}`}
        style={style}
        type={type || 'string'}
        startAdornment={startComponent}
        endAdornment={
          showReset ? (
            <InputAdornment position="end">
              <IconButton onClick={handleReset}>
                <Clear className={classes.icon} />
              </IconButton>
            </InputAdornment>
          ) : (
            <InputAdornment position="end">
              <Search />
            </InputAdornment>
          )
        }
      />
    </>
  );
});
